import service from './request'

/**
 * 获取工单表单列表信息
 */
 export const orderFormDesignGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/orderFormDesign/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单表单信息
 */
 export const orderFormDesignGetInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderFormDesign/getInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 添加工单表单信息
 */
 export const orderFormDesignAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderFormDesign/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改工单表单信息
 */
 export const orderFormDesignUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderFormDesign/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除工单表单信息
 */
 export const orderFormDesignDelInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderFormDesign/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}


// WEBPACK FOOTER //
// ./src/http/formManagement.js